import { Parser } from "@siteimprove/alfa-parser";
import { Keyword } from "../textual/keyword.js";
import { Current } from "./current.js";
import { Hex } from "./hex.js";
import { HSL } from "./hsl.js";
import { Named } from "./named.js";
import { RGB } from "./rgb.js";
import { System } from "./system.js";
const { either } = Parser;
/**
 * @public
 */
export var Color;
(function (Color) {
    Color.current = Keyword.of("currentcolor");
    function hex(value) {
        return Hex.of(value);
    }
    Color.hex = hex;
    function hsl(hue, saturation, lightness, alpha) {
        return HSL.of(hue, saturation, lightness, alpha);
    }
    Color.hsl = hsl;
    function named(color) {
        return Named.of(color);
    }
    Color.named = named;
    function rgb(red, green, blue, alpha) {
        return RGB.of(red, green, blue, alpha);
    }
    Color.rgb = rgb;
    function system(keyword) {
        return Keyword.of(keyword);
    }
    Color.system = system;
    /**
     * {@link https://drafts.csswg.org/css-color/#typedef-color}
     */
    Color.parse = either(Hex.parse, Named.parse, RGB.parse, HSL.parse, Current.parse, System.parse);
    function isTransparent(color) {
        switch (color.type) {
            case "keyword":
                return false;
            case "color":
                return color.alpha.value === 0;
        }
    }
    Color.isTransparent = isTransparent;
})(Color || (Color = {}));
//# sourceMappingURL=color.js.map